import { createAction } from 'redux-actions';

export const RUTAS = createAction('RUTAS'); 

export const LOGIN = createAction('LOGIN', payload => payload);
export const LOGOUT = createAction('LOGOUT', payload => payload);

export const USUARIO = createAction('USUARIO', (custom, indLogin) => { return { custom, indLogin } });

export const TERCERO = createAction('TERCERO', payload => payload);
export const CONSTANTES = createAction('CONSTANTES', payload => payload);

/** Pasos flujo 1 */
export const PASO_ACTUAL_F1 = createAction('PASO_ACTUAL_F1', payload => payload);
export const PASO_ANTERIOR_F1 = createAction('PASO_ANTERIOR_F1', (paso, indFlujoCompleto) => { return { paso, indFlujoCompleto } });
export const PASO_SIGUIENTE_F1 = createAction('PASO_SIGUIENTE_F1', (paso, indFlujoCompleto) => { return { paso, indFlujoCompleto } });
/** Pasos flujo 2 */
export const PASO_ACTUAL_F2 = createAction('PASO_ACTUAL_F2', payload => payload);
export const PASO_ANTERIOR_F2 = createAction('PASO_ANTERIOR_F2', (paso, indFlujoCompleto) => { return { paso, indFlujoCompleto } });
export const PASO_SIGUIENTE_F2 = createAction('PASO_SIGUIENTE_F2', (paso, indFlujoCompleto) => { return { paso, indFlujoCompleto } });
/** Pasos flujo 3 */
export const PASO_ACTUAL_F3 = createAction('PASO_ACTUAL_F3', payload => payload);
export const PASO_ANTERIOR_F3 = createAction('PASO_ANTERIOR_F3', (paso, indFlujoCompleto) => { return { paso, indFlujoCompleto } });
export const PASO_SIGUIENTE_F3 = createAction('PASO_SIGUIENTE_F3', (paso, indFlujoCompleto) => { return { paso, indFlujoCompleto } });
/** Pasos flujo 4 */
export const PASO_ACTUAL_F4 = createAction('PASO_ACTUAL_F4', payload => payload);
export const PASO_ANTERIOR_F4 = createAction('PASO_ANTERIOR_F4', (paso, indFlujoCompleto) => { return { paso, indFlujoCompleto } });
export const PASO_SIGUIENTE_F4 = createAction('PASO_SIGUIENTE_F4', (paso, indFlujoCompleto) => { return { paso, indFlujoCompleto } });

/** Pasos flujo 0 */
export const PASO_ACTUAL_F0 = createAction('PASO_ACTUAL_F0', payload => payload);
export const PASO_ANTERIOR_F0 = createAction('PASO_ANTERIOR_F0', (paso, indFlujoCompleto) => { return { paso, indFlujoCompleto } });
export const PASO_SIGUIENTE_F0 = createAction('PASO_SIGUIENTE_F0', (paso, indFlujoCompleto) => { return { paso, indFlujoCompleto } });

export const DATOS_PORTALCOBRANZAS = createAction('DATOS_PORTALCOBRANZAS', (keyObjeto, valueObjeto) => { return { keyObjeto, valueObjeto } }); 
export const EDITAR_ACTIVO = createAction('EDITAR_ACTIVO', (objeto, index) => { return { objeto, index } }); 
export const MOSTRAR_ACTIVO = createAction('MOSTRAR_ACTIVO', (flag, index) => { return { flag, index } }); 
export const ELIMINAR_ACTIVO = createAction('ELIMINAR_ACTIVO', (index) => { return { index } }); 


export const FLUJO_THANKUPAGE = createAction('FLUJO_THANKUPAGE', (flujo) => { return { flujo } });

export const CARGAR_IMAGEN_LOCAL = createAction('CARGAR_IMAGEN_LOCAL', (imagenesLocal) =>{ return { imagenesLocal } });
export const CARGAR_IMAGEN_FACTURA = createAction('CARGAR_IMAGEN_FACTURA', (imagenesFactura) =>{ return { imagenesFactura } });

export const ELIMINAR_IMAGEN_LOCAL = createAction('ELIMINAR_IMAGEN_LOCAL', (index) =>{ return { index } });
export const ELIMINAR_IMAGEN_FACTURA = createAction('ELIMINAR_IMAGEN_FACTURA', (index) =>{ return { index } });

export const CARGAR_IMAGEN_ACTIVO = createAction('CARGAR_IMAGEN_ACTIVO', (file, index) =>{ return { file, index } });
export const ELIMINAR_IMAGEN_ACTIVO = createAction('ELIMINAR_IMAGEN_ACTIVO', (index) =>{ return { index } });

// Error de servicio
export const errorServices = createAction('errorServices', payload => payload);

//actions que traen datos para el front
export const seleccionarPoliza 	= createAction('seleccionarPoliza', (numpoliza, polizas, flagUpdate) => { return { numpoliza, polizas, flagUpdate }});
export const setItemPoliza = createAction('setItemPoliza', (itemPoliza) => { return { itemPoliza }});


export const obtenerPolizas 	= createAction('polizas', payload => payload);
export const obtenerParametros 	=  createAction('parametros', payload => payload);
export const obtenerDeclarante 	= createAction('declarante', payload => payload);
export const obtenerCoberturas 	= createAction('cobertura', payload => payload);
// export const obtenerSiniestro 	= createAction('siniestro', payload => payload);


// activos
export const GRABAR_IMAGEN_ACTIVO = createAction('GRABAR_IMAGEN_ACTIVO', payload => payload);
export const IMAGE_PREVIEW = createAction('IMAGE_PREVIEW', payload => payload);


// activos declaracion de activos
export const obtenerActivosDeclarados = createAction('obtenerActivosDeclarados', payload => payload);

export const getDetallePol 	= createAction('getDetallePol', payload => payload);
export const getActivoSel 	= createAction('getActivoSel', payload => payload);


//activos declarados
export const imgActivosDeclarados = createAction('imgActivosDeclarados', payload => payload);
export const detalleActivosDeclarados = createAction('detalleActivosDeclarados', payload => payload);
export const eliminarActivoDeclarado = createAction('eliminarActivoDeclarado', payload => payload);

//Nuevos Agregados
export const obtenerRoles = createAction('obtenerRoles', payload => payload);
export const obtenerRemesas = createAction('obtenerRemesas', payload => payload);

//Métodos de pago
export const obtenerMetodosPago = createAction('obtenerMetodosPago', payload => payload);

